import React, { useEffect, useState } from 'react';
import {
  ALL_DAY_EVERY_DAY,
  ALL_DAY_RU,
  AROUND_THE_CLOCK,
  DEFAULT_TIME_TABLE,
} from 'shared/consts/schedule';
import { Switcher, TimeRangePicker } from 'shared/ui';
import {
  daysOfWeekEng,
  IDayTimeSlots,
  IWeekWorkTime,
  IWorkingTimeDay,
} from '../../interfaces/time-table-input.interface';
import styles from './every-day-input.module.scss';

export const EveryDayInput: React.FC<IDayTimeSlots> = ({
  onChangeHandler,
  newDaySlot,
}) => {
  const [timeSlot, setTimeSlot] = useState<IWeekWorkTime>(
    newDaySlot.monday.start ? newDaySlot : DEFAULT_TIME_TABLE
  );
  const [reserveTimeSlot, setReserveTimeSlot] =
    useState<IWeekWorkTime>(DEFAULT_TIME_TABLE);

  useEffect(() => {
    onChangeHandler(timeSlot);
  }, [timeSlot]);

  const isAllDayWorking = () =>
    timeSlot.monday.start === '00:00' && timeSlot.monday.end === '00:00';

  const handleAllDaySwitcher = () => {
    let newTimeTable: IWeekWorkTime;
    if (isAllDayWorking()) {
      newTimeTable = reserveTimeSlot;
      setReserveTimeSlot(DEFAULT_TIME_TABLE);
    } else {
      setReserveTimeSlot(timeSlot);
      newTimeTable = createTimeTable(ALL_DAY_EVERY_DAY);
    }
    setTimeSlot(newTimeTable);
  };

  const createTimeTable = (timeRange: IWorkingTimeDay): IWeekWorkTime => {
    const newTable: IWeekWorkTime = {};
    for (let i = 0; i < 7; i++) {
      newTable[daysOfWeekEng[i]] = {
        start: timeRange.start,
        end: timeRange.end,
      };
    }
    return newTable;
  };

  const handleTimeChange = (data: {
    dayIndex: number;
    timeRange: IWorkingTimeDay;
  }) => {
    const newTimeTable = createTimeTable(data.timeRange);
    setTimeSlot(newTimeTable);
    setReserveTimeSlot(newTimeTable);
  };

  return (
    <div className={styles.content__container}>
      <div className={styles.content__days}>
        <div className={styles.days__day}>
          <TimeRangePicker
            value={isAllDayWorking() ? ALL_DAY_RU : undefined}
            timeRange={timeSlot.monday}
            onChange={(timeRange: {
              dayIndex: number;
              timeRange: IWorkingTimeDay;
            }) => handleTimeChange(timeRange)}
            index={0}
          />
          <div className={styles.day__title}>{AROUND_THE_CLOCK}</div>
          <Switcher
            isActive={isAllDayWorking()}
            onClick={handleAllDaySwitcher}
          />
        </div>
      </div>
    </div>
  );
};
